export default __webpack_public_path__ + "static/media/swatchbook.38503479.svg";